/**
 * Page: Dev portal
 */
import React, { ReactElement, CSSProperties, useState } from 'react';
import { DocumentationSidebar } from '../common/DocumentationSidebar';
import { DocumentationToolbar } from '../common/DocumentationToolbar';
import { IPortalPageProps } from '../../types';
import { PortalBody } from './PortalBody';
import { NavigateToDocumentationPage } from '../common/navigation';

/**  Globals  */
const FONT_FAMILY = `Inter, Helvetica, sans-serif`;
const ROOT_STYLE: CSSProperties = {
    fontFamily: FONT_FAMILY,
    fontSize: '14px',
    height: '100%',
};

/**  Exports  */
export function PortalPage(props: IPortalPageProps): ReactElement {
    /**
     * NB: Cannot use hooks in top-level page component
     */

    return <PortalPageContent {...props} />;
}

function PortalPageContent(props: IPortalPageProps): ReactElement {
    /**
     * State: URL
     */
    const [url, setUrl] = useState(props.url);
    const [login_path, setLoginPath] = useState(props.login_path);
    const [originalUrl, setOriginalUrl] = useState(props.originalUrl);

    /**
     * Methods
     */
    const navigateToDocumentationPage = NavigateToDocumentationPage({
        hostname: props.hostname,
        url_prefix: props.url_prefix,
        url,
        setUrl,
        setLoginPath,
        setOriginalUrl,
    });

    /**
     * Render
     */
    const sidebar_props = {
        ...props,
        url,
        login_path,
        originalUrl,
        navigateToDocumentationPage,
    };

    // @ts-ignore
    delete sidebar_props.page;

    return (
        <div style={ROOT_STYLE}>
            <noscript>Please enable JavaScript to access this page.</noscript>

            {/* Navigation */}
            <DocumentationSidebar {...sidebar_props} />
            <DocumentationToolbar {...sidebar_props} />

            {/* Content */}
            <PortalBody {...props} />
        </div>
    );
}
